<template>
  <div>
    <Navbar :toReset="(url) => this.reset(url)" />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Operasi" :toReset="(url) => this.reset(url)" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Gagal Menyimpan Data',
              content:
                'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil Menyimpan Data',
              content: 'Penyimpanan data berhasil dilakukan',
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <DetailTop :detailTop="detailTop" />
          <div class="row mb-2">
            <div class="col-md-7 pr-1">
              <DetailLeft :detailLeftTop="detailLeftTop" />
            </div>
            <div class="col-md-5 pl-1">
              <DetailRight :detailRightTop="detailRightTop" />
            </div>
          </div>
          <!--form action="/operasi/save" method="POST" enctype="multipart/form-data"-->
          <div class="row mt-4 mb-2">
            <div class="col-md-6">
              <FormRow
                v-for="row in upperForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
          </div>
          <div class="row mb-5">
            <div class="col-md-6">
              <FormRow
                v-for="row in leftForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
            <div class="col-md-6">
              <FormRow
                v-for="row in rightForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
          </div>
          <div class="py-1 my-5"></div>
          <div class="card p-3 float-bottom">
            <div class="row">
              <div class="col-md-12">
                <button
                  @click="handleForm"
                  class="
                    btn btn-primary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  Jadwalkan Operasi
                </button>
                <button
                  class="
                    btn btn-outline-danger btn-no-outline
                    float-right
                    text-uppercase
                  "
                  @click="() => reset('/operasi')"
                >
                  Batalkan
                </button>
              </div>
            </div>
          </div>

          <!--/form-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import DetailTop from "@/components/DetailTop.vue";
import DetailLeft from "@/components/DetailLeft.vue";
import DetailRight from "@/components/DetailRight.vue";
import Alert from "@/components/Alert.vue";
import {
  resetForms,
  setPatientIntro,
  setRawatIntro,
  validateForms,
} from "@/data/helper.js";
// import { HTTP } from "@/config.js";
import { data, upperForm, leftForm, rightForm } from "@/data/OperasiForm.js";

export default {
  name: "OperasiForm",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    DetailTop,
    DetailLeft,
    DetailRight,
    Alert,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      slug: "",
      validated: false,
      data: data,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      leftForm,
      rightForm,
      upperForm,
      formSet: {
        id_ralan: null,
        tanggal: "",
        sign_in: "",
        // kategori_tindakan: "",
        // golongan_tindakan: "",
        nama_operasi: "",
        // jenis_anestesi: "",
        generate_form: "",
        file_persetujuan: null,
        id_dokter_operator: 0,
      },
      saveSuccess: false,
      saveFailed: false,
    };
  },
  methods: {
    handleForm: async function() {
      this.errors = [];
      let formData = new FormData();
      var self = this;
      let valid = this.validateForm();
      ////console.log(valid);
      ////console.log(this.formSet);
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          ////console.log("==================formdata========");
          ////console.log(key);
          ////console.log(self.formSet[key]);
          ////console.log("==================formdata========");
          if (key == "file_persetujuan") {
            if (self.formSet[key]) {
              formData.append(key, self.formSet[key]);
            }
          } else {
            if (key != "generate_form") {
              formData.append(key, self.formSet[key]);
            }
          }
        });
        try {
          let result = await this.$store.state.HTTP.post("operasi", formData);
          ////console.log(result);
          if (result.status == "200") {
            this.saveFailed = false;
            this.saveSuccess = true;
            var that = this;
            setTimeout(function() {
              that.saveSuccess = false;
              that.reset(
                `/operasi/detail/${that.$route.params.id}/${result.data.id}`
              );
              // that.$router.push(`/operasi/detail/${that.$route.params.id}/${result.data.id}`);
            }, 1000);
          } else {
            ////console.log(result.status);
            this.errors.push(result.status);
            this.saveFailed = true;
          }
        } catch (e) {
          ////console.log(e);
          this.errors.push(e);
          this.saveFailed = true;
        }
      } else {
        ////console.log("tidak valid");
      }
    },
    handleChange(e, create) {
      ////console.log(create);
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          if (e.target.files && e.target.files.length) {
            this.formSet[e.target.name] = e.target.files[0];
          }
        }
      } else {
        this.formSet[e.target.name] = e.target.value;
      }
      ////console.log(this.formSet[e.target.name]);
    },
    reset(url, stay) {
      // if (this.validated) {
      resetForms(
        this.formSet,
        [this.leftForm, this.rightForm, this.upperForm],
        true,
        this.handleChange
      );
      // }

      if (!url) {
        this.$router.go(-1);
      } else {
        ////console.log(url);
        this.$router.push(url);
      }
    },

    validateForm: function() {
      let valid = true;
      let self = this;
      ////console.log(self.formSet);
      let forms = [this.upperForm, this.leftForm, this.rightForm].map(function(
        form
      ) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (
              !column.optional &&
              column.type != "hidden" &&
              !self.formSet[column.name]
            ) {
              valid = false;
              column.error = "Kolom ini wajib diisi";
            } else if (
              [
                "number",
                "money",
                "addon-right",
                "addon-left",
                "percentage",
              ].indexOf(column.type) > -1 &&
              !column.negativeValue &&
              parseInt(self.formSet[column.name]) < 0
            ) {
              valid = false;
              column.error = "Nilai yang diisi tidak boleh negatif";
            } else {
              column.error = "";
            }
            if (self.formSet[column.name]) {
              if (column.type == "file" || column.type == "image") {
                var reader = new FileReader();
                reader.onload = function(e) {
                  column.value = e.target.result;
                };
                reader.readAsDataURL(self.formSet[column.name]);
              } else {
                column.value = self.formSet[column.name];
              }
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.upperForm = forms[0];
      this.leftForm = forms[1];
      this.rightForm = forms[2];
      this.validated = true;
      return valid;
    },
    generateForm() {
      let route = this.$router.resolve({
        path: `/document/${this.slug}/persetujuan`,
      });
      // let route = this.$router.resolve('/link/to/page'); // This also works.
      window.open(route.href, "_blank");
    },
    fetchDoctors: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "dokter?per_page=9999999999"
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log(result.data);
          let doctors = result.data.data;
          //console.log(doctors);
          this.leftForm[1].columns[0].options = doctors.map(function(item) {
            item.label = `${item.kode} | ${item.nama}`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
        } else {
          this.displayNotFoundError();
        }
        // this.fetchNurses();
      } catch (e) {
        //console.log(e);
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.formSet["id_ralan"] = this.$route.params.id;
    ////console.log(this.formSet['id_ralan']);
    await this.fetchDoctors();
    try {
      let result = await this.$store.state.HTTP.get(
        `ralan/${this.$route.params.id}?darurat=${this.$route.params.darurat}`
      );
      ////console.log(result);
      if (result.status == "200") {
        ////console.log('ralan');
        ////console.log(result.data);
        this.ralan = result.data;
        this.detailTop = setPatientIntro(result.data.pasien);
        let detailRawat = setRawatIntro(result.data);
        this.detailLeftTop = detailRawat.detailLeftTop;
        this.detailRightTop = detailRawat.detailRightTop;
        this.slug = this.CryptoJS.AES.encrypt(
          JSON.stringify(this.ralan),
          this.$store.state.simrsSecretPassphrase
        )
          .toString()
          .replace(/\//g, "fRWdSl45h");
        this.rightForm[0].columns[0].function = () => this.generateForm();
        this.rightForm[0].columns.splice(0, 1, this.rightForm[0].columns[0]);
        ////console.log('ralan');
        // this.formSet['no_rawat']=result.data.no_rawat;
        // this.formSet['darurat']=result.data.no_rawat;
        // this.formSet['no_rm']=result.data.pasien.no_rm;
        // this.formSet['id_dokter']=result.data.id_dokter;
        ////console.log(this.formSet['no_rawat']);
      } else {
        this.displayNotFoundError();
      }
    } catch (e) {
      ////console.log(e);
    }
  },
};
</script>
